import { Alert } from '#/graphql/types';
import { Key } from '#/types';

export const mutationFields: Key<Alert>[] = ['state'];
